/**
 * @file Entrypoint for the certificate display page (for user certificate)
 */
import { DOMContentLoadedPromise } from '@@/bits/dom'
import { captureException, setScope } from '@@/bits/error_tracker'
import window, { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import DashboardSettingsBeltProgressCertificateDisplay from '@@/vuecomponents/DashboardSettingsBeltProgressCertificateDisplay.vue'
import { configure as configureArvo } from '@padlet/arvo'

// Wait for DOM and configure Arvo from vueStartingState
DOMContentLoadedPromise.then(() => {
  const { arvoConfig, currentUserId } = ww.vueStartingState
  if (currentUserId) {
    setScope({ userId: currentUserId })
  }
  if (arvoConfig) {
    void configureArvo(arvoConfig)
  }
}).catch(captureException)

setupVueApp({
  el: '#user-certificate',
  rootComponent: DashboardSettingsBeltProgressCertificateDisplay,
  usePinia: true,
})
  .then((vueInstance) => {
    window.app = vueInstance
  })
  .catch(captureException)
